import React, { useEffect } from 'react'

import './design-system/globals.css'

import Route from './Routes'
import { installGlobalNumberInputWheelGuard } from 'helpers/preventNumberInputWheel'
import { installNativeFormValidationFeedback } from 'helpers/nativeFormValidationFeedback'
import { UpdateModal } from 'Components/Common/UpdateModal'
import { SupportSessionBanner, SupportSessionBootstrap } from 'Components/Security/SupportSessionBanner'

function App() {
 useEffect(() => {
 const uninstallWheelGuard = installGlobalNumberInputWheelGuard()
 const uninstallValidationFeedback = installNativeFormValidationFeedback()

 return () => {
 uninstallWheelGuard?.()
 uninstallValidationFeedback()
 }
 }, [])

 return (
 <React.Fragment>
 <SupportSessionBootstrap />
 <SupportSessionBanner />
 <Route />
 <UpdateModal />
 </React.Fragment>
 )
}

export default App
